module.exports = __webpack_public_path__ + "static/media/logo.d2386d9e.svg";